export type PlanTier = 'Free Trial' | 'Basic' | 'Pro';

export interface UsageLimit {
  notes: number | 'unlimited';
  forms: number | 'unlimited';
  aiPrompts: number | 'unlimited';
}

export const USAGE_LIMITS: Record<PlanTier, UsageLimit> = {
  'Free Trial': {
    notes: 15,
    forms: 5,
    aiPrompts: 5,
  },
  'Basic': {
    notes: 100,
    forms: 10,
    aiPrompts: 10,
  },
  'Pro': {
    notes: 'unlimited',
    forms: 'unlimited',
    aiPrompts: 'unlimited',
  },
};
